import { useEffect } from 'react';

import { Mixpanel } from 'mixpanel';
import useUser from 'api/hooks/useUser';

const useFocusedModule = (screenName: string) => {
  const { data } = useUser();
  useEffect(() => {
    let result = 0;
    const interval = setInterval(() => {
      result += 1;
    }, 1000);

    return () => {
      if (data) {
        Mixpanel.track(screenName, {
          role: data?.role?.name,
          organization: data?.organization,
          duration: result,
        });
      }

      clearInterval(interval);
    };
  }, []);
};

export default useFocusedModule;
